const colors = {
  cancelButton: "#EFEFEF",
  red: "red",
  yellow: "#FFBA49",
  blue: "blue",
  black: "black",
  green: "green",
  themeColor: "#E36E00",
  lightBlue: "#566faf",
  grayborderColor: "#f0f0f0",
  orange: "#fd7c43",
  white: "white",
  border: "#eef7fc",
  icon: "#058be2",
  search: "#586FAB",
  grey: "grey",
  peach: "#fef4e9",
  sienna: "#dc7300",
  bordertask: "#E2E4E7",
  borderSprintPlanning: "#F7F8F9",
  sprintplanningbackground: "#f7f8f9",
  hoverColor: "#1677FF",
  borderColor: "#D9D9D9",
  uploadIcon: "#478FCA",
  dropzonetext: "#777",
  buttonBackground: "red",
  buttonText: "white",
  inkblue: "#468ad2",
  attachment: "#E36E00",
  sprintCardBorder: "#0da1f3",
  activityBackC: "#F8F8FA",
  bugID: "#1976D2",
  darkBlue: "#35AFEC",
  emailIcon: "#18A8F0",
  greyColor: "#eeeeee",
  // Modern 2025 colors
  modernPrimary: "#E36E00",
  modernSecondary: "#FFAE00",
  modernSuccess: "#10b981",
  modernWarning: "#f59e0b",
  modernError: "#ef4444",
  modernInfo: "#3b82f6",
  modernGray: {
    50: "#f9fafb",
    100: "#f3f4f6",
    200: "#e5e7eb",
    300: "#d1d5db",
    400: "#9ca3af",
    500: "#6b7280",
    600: "#4b5563",
    700: "#374151",
    800: "#1f2937",
    900: "#111827",
  },
  buttonbackgroundfilter: " #FFF4E0",
};

const gradient = {
  // themeGradient: "linear-gradient(180deg, #e65c00 0%, #f5af19 100%)",
  themeGradient: "linear-gradient(180deg,  #E36E00  0%, #FFAE00 100%)",
  backgroundTheme: "linear-gradient(135deg, #fef4e9 0%, #ffe4b3 100%);",
  choosefile:
    "linear-gradient(90deg, rgba(227,227,227,1) 0%, rgba(241,241,241,1) 100%);",
  send: "linear-gradient(135deg, #0073E6 0%, #00B4DB 100%)",
  edit: "linear-gradient(135deg, #1565C0 0%, #42A5F5 100%)",
  delete: "linear-gradient(135deg, #D32F2F 0%, #FF5252 100%)",
  download: "linear-gradient(135deg, #388E3C 0%, #4CAF50 100%)",
  // Modern 2025 gradients
  modernPrimary: "linear-gradient(135deg, #E36E00 0%, #FFAE00 100%)",
  modernSecondary: "linear-gradient(135deg, #f093fb 0%, #f5576c 100%)",
  modernSuccess: "linear-gradient(135deg, #4facfe 0%, #00f2fe 100%)",
  modernWarning: "linear-gradient(135deg, #fa709a 0%, #fee140 100%)",
  modernError: "linear-gradient(135deg, #ff9a9e 0%, #fecfef 100%)",
  modernGlass:
    "linear-gradient(135deg, rgba(255, 255, 255, 0.1) 0%, rgba(255, 255, 255, 0.05) 100%)",
  modernBackground: "linear-gradient(135deg, #fef4e9 0%, #ffe4b3 100%)",
};

const headerCard = {
  borderRadius: "8px",
};

const droppableCard = {
  borderRadius: "15px",
  backgroundColor: "#F7F8F9",
};

const draggableCard = {
  borderRadius: "8px",
};

// Modern 2025 design tokens
const modernTokens = {
  borderRadius: {
    sm: "8px",
    md: "12px",
    lg: "16px",
    xl: "20px",
    full: "9999px",
  },
  spacing: {
    xs: "4px",
    sm: "8px",
    md: "16px",
    lg: "24px",
    xl: "32px",
    xxl: "48px",
  },
  shadows: {
    sm: "0 2px 8px rgba(0, 0, 0, 0.05)",
    md: "0 4px 15px rgba(0, 0, 0, 0.1)",
    lg: "0 8px 25px rgba(0, 0, 0, 0.15)",
    xl: "0 20px 40px rgba(0, 0, 0, 0.2)",
  },
  transitions: {
    fast: "all 0.2s ease",
    normal: "all 0.3s ease",
    slow: "all 0.5s ease",
  },
};

export const getBorderColor = (type) => {
  switch (type) {
    case 1:
      return "4px solid #676668";
    case 2:
      return "4px solid #FD6C1C";
    default:
      return "4px solid red";
  }
};

const theme = {
  colors,
  headerCard,
  droppableCard,
  draggableCard,
  gradient,
  modernTokens,
};

export default theme;
